//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class ActivityActionService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[ActivityAction.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/activity-action/detail', {'params':params});
	};

	//GeneratorFlag:[ActivityAction.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/activity-action/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}